import { ViewModeType } from '@libs/models/viewModeType.enum';
import { SelectorOption } from '@libs/models/selector-option.interface';
import { enumToSelectorOptions } from '@libs/helpers';

export const VIEW_MODES: SelectorOption[] = enumToSelectorOptions(ViewModeType);
